import Lottie from 'lottie-react';

import gad7 from '../jsons/gad7.json';

const LottieGad7 = props => {
  return <Lottie animationData={gad7} loop={false} {...props} />;
};

export default LottieGad7;
